import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import AdditionalService from '../../../models/AdditionalService';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import ProductAdditionalServicesModal from '../../product/ProductAdditionalServicesModal';
import { modelOf } from '../../../prop-types';
import { FormattedMessage } from 'react-intl';
import ButtonLink from '../../common/ButtonLink';
import Icon from '../../common/Icon';
import { ADDITIONAL_SERVICES_ID } from '../../product/ProductPageContent';
import AddToCartPostalCodeValidation from '../AddToCartPostalCodeValidation';
import FormField from '../../../models/FormField';
import Product from '../../../models/Product';

@observer
class AddToCartServices extends Component {
  constructor(props) {
    super(props);
    this.scrollToTab = this.scrollToTab.bind(this);
  }
  renderAdditionalServicesTabButton = () => {
    const { configStore } = this.props;

    const ifAdditionalServicesModalEnabled =
      configStore.productPage.enableAdditionalServicesModal;

    if (!ifAdditionalServicesModalEnabled) {
      return null;
    }

    return (
      <span className="AddToCart__additional-services-tab-button">
        <ButtonLink
          className="AddToCart__additional-services-tab-button-text"
          onClick={this.scrollToTab}
        >
          <FormattedMessage
            id="additionalService.availableServices"
            defaultMessage="Check available services here"
          />
        </ButtonLink>
        <span className="AddToCart__additional-services-tab-button-icon">
          <Icon name="caret-down" />
        </span>
      </span>
    );
  };

  scrollToTab = () => {
    const { scrollToServices } = this.props;

    scrollToServices && scrollToServices(ADDITIONAL_SERVICES_ID);
  };

  renderServices = () => {
    const { configStore } = this.props;
    const ifAdditionalServicesModalEnabled =
      configStore.productPage.enableAdditionalServicesModal;

    return ifAdditionalServicesModalEnabled
      ? this.renderServiceModal()
      : this.getServices();
  };

  renderServiceModal = () => {
    const { uiStore, onAddToCart, disabled } = this.props;
    const isOpen = uiStore.additionalServicesModal.isOpen;

    if (!isOpen) {
      return null;
    }

    return (
      <ProductAdditionalServicesModal
        onAddToCart={onAddToCart}
        disabled={disabled}
      >
        {this.renderPostalCodeValidationInput()}
        {this.getServices()}
      </ProductAdditionalServicesModal>
    );
  };

  getServices = () => {
    const { services, renderService } = this.props;

    return services.map(renderService);
  };

  renderPostalCodeValidationInput() {
    const {
      product,
      ifValidForm,
      onSubmit,
      onChange,
      postalCodeField
    } = this.props;

    if (!postalCodeField) {
      return null;
    }

    return (
      <AddToCartPostalCodeValidation
        product={product}
        postalCodeField={postalCodeField}
        ifValidForm={ifValidForm}
        handleSubmit={onSubmit}
        handleChange={onChange}
      />
    );
  }

  render() {
    const { configStore } = this.props;
    const ifAdditionalServicesModalEnabled =
      configStore.productPage.enableAdditionalServicesModal;

    return (
      <div className="AddToCart__additional-services-wrapper">
        {this.renderAdditionalServicesTabButton()}
        {!ifAdditionalServicesModalEnabled &&
          this.renderPostalCodeValidationInput()}
        {this.renderServices()}
      </div>
    );
  }
}

AddToCartServices.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  disabled: PropTypes.bool.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  product: modelOf(Product).isRequired,
  renderService: PropTypes.func.isRequired,
  services: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(AdditionalService)),
    PropTypes.arrayOf(modelOf(AdditionalService))
  ]).isRequired,
  ifValidForm: PropTypes.bool,
  scrollToServices: PropTypes.func,
  postalCodeField: modelOf(FormField)
};

export default inject('configStore', 'uiStore')(AddToCartServices);



// WEBPACK FOOTER //
// ./src/components/cart/AddToCartServices/index.jsx